import PubNub from 'pubnub';

const pubnub = new PubNub({
  publishKey: 'pub-c-dd92ee97-045b-4e9e-ae69-230326e5c749',
  subscribeKey: 'sub-c-b077ba88-1676-11e8-92ea-7a3d09c63f1f',
  heartbeatInterval: 61,
  ssl: process.env.NODE_ENV === 'production',
});

// pubnub.deleteMessages({
//   channel: 'flynn',
// });
export default pubnub;



// WEBPACK FOOTER //
// ./src/pubnub/index.js